module.exports = __webpack_public_path__ + "static/media/welcome5.fa243e43.png";